import { render } from "./ForeignDocumentsModal.vue?vue&type=template&id=77aec00b"
import script from "./ForeignDocumentsModal.vue?vue&type=script&lang=js"
export * from "./ForeignDocumentsModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__